import { render, staticRenderFns } from "./oldCustomerRepurchaseRegionPage.vue?vue&type=template&id=21eb61e2&scoped=true&"
import script from "./oldCustomerRepurchaseRegionPage.vue?vue&type=script&lang=js&"
export * from "./oldCustomerRepurchaseRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./oldCustomerRepurchaseRegionPage.vue?vue&type=style&index=0&id=21eb61e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb61e2",
  null
  
)

export default component.exports